//=================================================================
// ダイナミックリンク用スクリプト
//=================================================================

// Vue
import router from '@/router';

// ダイナミックリンク
import { FirebaseDynamicLinks } from '@pantrist/capacitor-firebase-dynamic-links';

// メモった！、キニッタ！共通
import * as GVar from '@/components/00/Var00';
import * as Tools from '@/components/00/Tools';         // 共通ツール
import * as GFunc from '@/components/00/Common00';    // 共通メソッド

// キニッタ！専用
import * as LVar from '@/components/05/Var05001';       // キニッタ！専用変数
import * as LFunc from '@/components/05/Common05001';   // キニッタ！専用メソッド

/**
 * ダイナミックリンク用リスナーを設定
 */
export function addDynamicLinkListener() 
{
    /**
     * ダイナミックリンク用リスナー
     * @param 例) data={"url":"https://memotta.com/01/p/login.html?mn=782&ymd=20220101"} 
     */
    FirebaseDynamicLinks.addListener('deepLinkOpen', async (data: any) => 
    {
        if ( GFunc.isDebugEnabled() ) {console.log("addDynamicLinkListener()");}
        dynamicLinkDispatcher(Tools.getParamsDeeplink(data.url));       
    });
}

/**
 * ダイナミックリンクディスパッチャー(スマフォ専用)
 *
 * @param params 店舗ID(shpid)又はイベントNo.(en)をキーにした連想記憶配列
 */
export const dynamicLinkDispatcher = async function (params: any)
{
    if ( GFunc.isDebugEnabled() ) {console.log("dynamicLinkDispatcher()");}
    const shpId = params[LFunc.getProperty("dynamiclink.05001.02.param.shpid")!]; // 引数で受け取った店舗ID
    const en = params[LFunc.getProperty("dynamiclink.05001.02.param.en")!];       // 引数で受け取ったイベントNo.
    // アプリ起動モードをダイナミックリンクに設定
    GVar.setRunMode("2");
    if ( shpId != null )
    {
        GVar.setRunMode("2");
        // パラメーターで受け取った店舗が既に表示中の場合は何もしない
        if ( GVar.curPage == "S05001003" && LVar.pCurShpId == Number(shpId) ) { return; }

        // S05001003が表示中の場合、ページが書き変sわらないのでqueryをparamsに置き換えて呼び出す
        // ただし、異なる店舗のQRコードを連続して読み込んだ場合はホームページが書き変わらない（バグ）
        // お店ホームページへ遷移
        console.log('******** /S05001003/'+LFunc.getProperty("dynamiclink.05001.02.param.shpid")+'='+shpId);
        router.push('/S05001003/'+LFunc.getProperty("dynamiclink.05001.02.param.shpid")+'='+shpId);
    }
    else if ( en != null )
    {       
        //
        // push通知又はイベントリマインダーメールから遷移した場合
        //

        // アプリ起動モードをダイナミックリンクに設定
        GVar.setRunMode("2");
        // パラメーターで受け取ったイベントが既に表示中の場合は何もしない
        if ( GVar.curPage == "S05001008" && GVar.curEventNo == Number(en) ) { return; }
        // イベント詳細表示ページへ遷移
        router.push('/S05001008/'+LFunc.getProperty("dynamiclink.05001.02.param.en")+'='+en); 
    }
    else
    {
        // パラメーターが設定されてない場合は、何もしない（検索ページが表示される）        
    }
}